import Vue from 'vue';
import Component from 'vue-class-component';
import { formatDate, Icon } from 'wc-lib';
import { Service } from '../service';
import Config from '../config';
import { Notification } from '../model/notification';

require('../../icons/urgent.svg');
require('../../icons/important.svg');
require('../../icons/info.svg');

@Component({
  template: require('./notifications.html'),
  components: {
    'wc-icon': Icon,
  }
})
export class Notifications extends Vue {
  title: string = '';
  showNotifications: boolean = true;
  notifications: Notification[] = [];
  notificationIndex: number = -1;
  
  created() {
    this.title = Config.title;
    const now = new Date();
  }

  async mounted() {
    let now = new Date();
    this.notifications = (await Service.getNotifications(0, 100)).notifications;
    localStorage.setItem('lastReadDateTime', now.toString());
  }

  formatDate(value: string) {
    return formatDate(value);
  }

  closeNotifications() {
    this.showNotifications = false;
  }
}



// WEBPACK FOOTER //
// src/views/notifications.ts